import { useLang } from "./i18n";
import { track } from "./analytics";

// links: [{ label, onClick, active }]
export default function SiteHeader({ links }) {
  const { lang, t, setLang } = useLang();
  const next = lang === "th" ? "en" : "th";

  return (
    <header className="bce-header">
      <div className="bce-brand">
        <img className="bce-logo" src={`${process.env.PUBLIC_URL || ""}/images/BigCLogo.png`} alt="Big C" width="48" height="48" />
        <span className="bce-brand-title">
          Big C Shopping Bag
          <em>{t("brandSub")}</em>
        </span>
      </div>
      <nav className="bce-nav" aria-label={t("menuLabel")}>
        {links.map((l) => (
          <button
            key={l.label}
            type="button"
            className={l.active ? "is-active" : ""}
            aria-current={l.active ? "page" : undefined}
            onClick={l.onClick}
          >
            {l.label}
          </button>
        ))}
      </nav>
      {/* ปุ่มภาษา: มุมขวาบนของส่วนหัว (บนมือถืออยู่แถวเดียวกับโลโก้) */}
      <button
        type="button"
        className="bce-lang"
        lang={next}
        aria-label={t("langSwitchLabel")}
        onClick={() => {
          track("language_change", { lang: next });
          setLang(next);
        }}
      >
        <span className={lang === "th" ? "is-on" : ""}>TH</span>
        <span className={lang === "en" ? "is-on" : ""}>EN</span>
      </button>
    </header>
  );
}
